<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('订单表')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <out-order-modal ref="modalForm" @ok="modalFormOk"></out-order-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import OutOrderModal from './modules/OutOrderModal'

  export default {
    name: 'OutOrderList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      OutOrderModal
    },
    data () {
      return {
        description: '订单表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'工单号',
            align:"center",
            dataIndex: 'no'
          },
          {
            title:'处方号',
            align:"center",
            dataIndex: 'outNo'
          },
          {
            title:'患者姓名',
            align:"center",
            dataIndex: 'patientName'
          },
          {
            title:'0:女; 1:男; 2：未知',
            align:"center",
            dataIndex: 'patientGender'
          },
          {
            title:'患者年龄',
            align:"center",
            dataIndex: 'patientAge'
          },
          {
            title:'daijian:代煎; daipei:自煎',
            align:"center",
            dataIndex: 'workCate'
          },
          {
            title:'剂数',
            align:"center",
            dataIndex: 'paster'
          },
          {
            title:'每剂袋数',
            align:"center",
            dataIndex: 'packet'
          },
          {
            title:'科室',
            align:"center",
            dataIndex: 'hospitalOffice'
          },
          {
            title:'医生',
            align:"center",
            dataIndex: 'doctor'
          },
          {
            title:'医生id',
            align:"center",
            dataIndex: 'doctorId'
          },
          {
            title:'收货人id',
            align:"center",
            dataIndex: 'expressId'
          },
          {
            title:'快递方式',
            align:"center",
            dataIndex: 'expressType'
          },
          {
            title:'收件人姓名',
            align:"center",
            dataIndex: 'expressName'
          },
          {
            title:'医院',
            align:"center",
            dataIndex: 'hospital'
          },
          {
            title:'医院id',
            align:"center",
            dataIndex: 'hospitalId'
          },
          {
            title:'身份证号',
            align:"center",
            dataIndex: 'idCard'
          },
          {
            title:'用药方式',
            align:"center",
            dataIndex: 'medicineType'
          },
          {
            title:'剂量',
            align:"center",
            dataIndex: 'dose'
          },
          {
            title:'每日几剂',
            align:"center",
            dataIndex: 'dayOfTimes'
          },
          {
            title:'每袋ml',
            align:"center",
            dataIndex: 'unitMl'
          },
          {
            title:'服用量',
            align:"center",
            dataIndex: 'takingNumber'
          },
          {
            title:'每剂重量',
            align:"center",
            dataIndex: 'eachWeight'
          },
          {
            title:'快递编号',
            align:"center",
            dataIndex: 'courierNumber'
          },
          {
            title:'支付状态',
            align:"center",
            dataIndex: 'statuss'
          },
          {
            title:'金额',
            align:"center",
            dataIndex: 'amount'
          },
          {
            title:'预估时间',
            align:"center",
            dataIndex: 'forecastTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'排队人数',
            align:"center",
            dataIndex: 'lineCount'
          },
          {
            title:'快递名称',
            align:"center",
            dataIndex: 'courierName'
          },
          {
            title:'付款方式，寄付现结、货到付款',
            align:"center",
            dataIndex: 'courierType'
          },
          {
            title:'预估价格',
            align:"center",
            dataIndex: 'forecastAmount'
          },
          {
            title:'起点',
            align:"center",
            dataIndex: 'startPoint'
          },
          {
            title:'终点',
            align:"center",
            dataIndex: 'endPoint'
          },
          {
            title:'总重量',
            align:"center",
            dataIndex: 'weight'
          },
          {
            title:'件数',
            align:"center",
            dataIndex: 'count'
          },
          {
            title:'银行卡/微信',
            align:"center",
            dataIndex: 'payName'
          },
          {
            title:'预约流程',
            align:"center",
            dataIndex: 'appointmentProcess'
          },
          {
            title:'预约号',
            align:"center",
            dataIndex: 'appointmentNumber'
          },
          {
            title:'预约状态',
            align:"center",
            dataIndex: 'appointmentStatus'
          },
          {
            title:'提交时间',
            align:"center",
            dataIndex: 'submitTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/outOrder/outOrder/list",
          delete: "/outOrder/outOrder/delete",
          deleteBatch: "/outOrder/outOrder/deleteBatch",
          exportXlsUrl: "/outOrder/outOrder/exportXls",
          importExcelUrl: "outOrder/outOrder/importExcel",
          
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>